/* eslint-disable no-restricted-syntax */
/* eslint-disable prefer-destructuring */
import lod_ from "lodash";
import {
	Box,
	Card,
	CardContent,
	Divider,
	FormControl,
	Icon,
	InputLabel,
	ListSubheader,
	MenuItem,
	Select,
	Tooltip
} from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDTypography from "components/Basics/MDTypography";
import { useEffect, useState } from "react";

import ImageProviderOpenAI from "assets/images/provider/provider-openai.png";
import ImageProviderMistralAI from "assets/images/provider/provider-mistral.png";
import ImageProviderAzureOpenAI from "assets/images/provider/provider-azure-openai.svg";
import ImageProviderPinecone from "assets/images/provider/provider-pinecone.png";
import ImageProviderCohere from "assets/images/provider/provider-cohere.png";
import ImageProviderMongoDB from "assets/images/provider/provider-mongodb.png";
import ImageProviderAnthropic from "assets/images/provider/provider-anthropic.png";

import formActions from "redux-react/actions/formAction";
import { useDispatch, useSelector } from "react-redux";
import { t } from "i18next";
import MDButton from "components/Basics/MDButton";
import VectorMigrationDialog from "./VectorMigrationDialog";
/**
 * Display the correct provider with image
 * @returns
 */
const ProviderBox = ({ provider, color, alt }) => {
	switch (provider) {
		case "anthropic":
			return (
				<Tooltip title="Anthropic" placement="top" arrow>
					<MDBox display="flex" alignItems="center">
						<MDBox mr={1} display="flex" alignItems="center">
							<img src={ImageProviderAnthropic} alt="Anthropic" width="20" />
						</MDBox>
					</MDBox>
				</Tooltip>
			);
		case "mongoDB":
			return (
				<Tooltip title="MongoDB" placement="top" arrow>
					<MDBox display="flex" alignItems="center">
						<MDBox mr={1} display="flex" alignItems="center">
							<img src={ImageProviderMongoDB} alt="MongoDB" width="20" />
						</MDBox>
					</MDBox>
				</Tooltip>
			);
		case "pinecone":
			return (
				<Tooltip title="Pinecone" placement="top" arrow>
					<MDBox display="flex" alignItems="center">
						<MDBox mr={1} display="flex" alignItems="center">
							<img src={ImageProviderPinecone} alt="Pinecone" width="20" />
						</MDBox>
					</MDBox>
				</Tooltip>
			);
		case "cohere":
			return (
				<Tooltip title="Cohere" placement="top" arrow>
					<MDBox display="flex" alignItems="center">
						<MDBox mr={1} display="flex" alignItems="center">
							<img src={ImageProviderCohere} alt="Cohere" width="20" />
						</MDBox>
					</MDBox>
				</Tooltip>
			);
		case "openAI":
		case "ChatOpenAI":
			return (
				<Tooltip title="Open AI" placement="top" arrow>
					<MDBox display="flex" alignItems="center">
						<MDBox mr={1} display="flex" alignItems="center">
							<img src={ImageProviderOpenAI} alt="OpenAI" width="20" />
						</MDBox>
					</MDBox>
				</Tooltip>
			);
		case "mistralAI":
		case "MistralAI":
			return (
				<Tooltip title="Mistral AI" placement="top" arrow>
					<MDBox display="flex" alignItems="center">
						<MDBox mr={1} display="flex" alignItems="center">
							<img src={ImageProviderMistralAI} alt="MistralAI" width="20" />
						</MDBox>
					</MDBox>
				</Tooltip>
			);
		case "azureOpenAI":
		case "AzureOpenAI":
			return (
				<Tooltip title="Azure Open AI" placement="top" arrow>
					<MDBox display="flex" alignItems="center">
						<MDBox mr={1} display="flex" alignItems="center">
							<img src={ImageProviderAzureOpenAI} alt="AzureOpenAI" width="20" />
						</MDBox>
					</MDBox>
				</Tooltip>
			);
		default:
			if (!lod_.isNil(alt) && !lod_.isEmpty(alt)) {
				return (
					<MDBox display="flex" alignItems="center">
						<MDBox mr={1} display="flex" alignItems="center">
							<img src={alt} alt={provider} width="20" />
						</MDBox>
					</MDBox>
				);
			} else {
				return (
					<Tooltip title={provider} placement="top" arrow>
						<MDBox display="flex" alignItems="center">
							<MDBox mr={1} display="flex" alignItems="center">
								<Icon fontSize="small">help_outline</Icon>
							</MDBox>
						</MDBox>
					</Tooltip>
				);
			}
	}
};

/**
 * Item in the select
 * @param {*} param0
 * @returns
 */
const ModelCardItem = ({ model }) => {
	return (
		<MDBox display="flex">
			<ProviderBox provider={model.provider} alt={model?.options?.logoURL} />
			<MDBox>
				<MDTypography variant="h5" fontSize="medium">
					{model.name}
				</MDTypography>
				<MDBox>
					<MDTypography variant="body2" fontSize="small">
						{model.description}
					</MDTypography>
				</MDBox>
			</MDBox>
		</MDBox>
	);
};

/**
 * Vertical divider component
 * @returns {JSX.Element} Divider component with custom styles
 */
const VerticalDivider = () => {
	return (
		<Divider
			variant="vertical"
			sx={{
				width: "2px",
				minHeight: "5vh",
				height: "100%",
				color: "#ccc",
				opacity: "0.6",
				backgroundImage:
					"linear-gradient(to right, rgba(52, 71, 103, 0), rgba(52, 71, 103, 0.4), rgba(52, 71, 103, 0)) !important"
			}}
		/>
	);
};

/**
 * Item in the select
 * @param {*} param0
 * @returns
 */
const VectorModelCardItem = ({ model, embeddingsModels }) => {
	const algorithmModel = (embeddingsModels ?? []).find(m => m.code === model.algorithmCode);

	return (
		<MDBox
			flex="1"
			display="flex"
			flexDirection="row"
			alignItems="center"
			justifyContent="space-evenly"
		>
			{/* Vector model */}
			<MDBox flex="1" display="flex" flexDirection="row">
				<ProviderBox provider={model.provider} alt={model?.options?.logoURL} />
				<MDBox>
					<MDTypography variant="h5" fontSize="medium">
						{model.name}
					</MDTypography>
					<MDBox>
						<MDTypography variant="body2" fontSize="small">
							{model.description}
						</MDTypography>
					</MDBox>
				</MDBox>
			</MDBox>
			<VerticalDivider />
			{/* Index */}
			<MDBox flex="1">
				<MDBox display="flex" flexDirection="row" alignItems="center">
					<MDTypography variant="h6" fontSize="small">
						{t("CONFIG.vectorIndex")}
					</MDTypography>
					<Box
						sx={{
							marginLeft: 1,
							width: 8,
							height: 8,
							borderRadius: "50%",
							bgcolor: model.active ? "success.main" : "error.main"
						}}
					/>
				</MDBox>
				<MDTypography variant="body2" fontSize="small">
					{model.index}
				</MDTypography>
			</MDBox>
			<VerticalDivider />
			{/* Algorithm */}
			{lod_.isEmpty(model.algorithm) ? (
				<MDBox flex="1">
					<MDBox display="flex" flexDirection="row" alignItems="center">
						<MDTypography variant="h6" fontSize="small">
							{t("CONFIG.algorithmUnvailable")}
						</MDTypography>
						<Box
							sx={{
								marginLeft: 1,
								width: 8,
								height: 8,
								borderRadius: "50%",
								bgcolor: model.active ? "success.main" : "error.main"
							}}
						/>
					</MDBox>

					<MDTypography variant="body2" fontSize="small">
						{model.algorithmCode}
					</MDTypography>
				</MDBox>
			) : (
				<MDBox flex="1" display="flex" flexDirection="row">
					<ProviderBox
						provider={model.algorithm.provider}
						alt={model?.options?.logoURL || algorithmModel?.options?.logoURL}
					/>
					<MDBox>
						<MDBox display="flex" flexDirection="row" alignItems="center">
							<MDTypography variant="h6" fontSize="small">
								{t("CONFIG.algorithm")}
							</MDTypography>
							<Box
								sx={{
									marginLeft: 1,
									width: 8,
									height: 8,
									borderRadius: "50%",
									bgcolor: model.active ? "success.main" : "error.main"
								}}
							/>
						</MDBox>

						<MDTypography variant="body2" fontSize="small">
							{model.algorithm.name}
						</MDTypography>
					</MDBox>
				</MDBox>
			)}
		</MDBox>
	);
};

/**
 * Sort models by provider
 * @returns
 */
function sortModelsByName(models) {
	return models.sort((a, b) => {
		if (a.name.toLowerCase() < b.name.toLowerCase()) {
			return -1;
		}
		if (a.name.toLowerCase() > b.name.toLowerCase()) {
			return 1;
		}
		return 0;
	});
}

/**
 * Main component for models
 * @returns
 */
export default function ModelsPart({ settings, setSettings, loadConfig = () => {} }) {
	const dispatch = useDispatch();
	const permissions = useSelector(state => state.permissions?.permissions);

	const hasAdvancedSettings = permissions.includes("exec:faiqSettingsAdvancedSettings");

	const [llmModels, setLlmModels] = useState([]);
	const [rerankModels, setRerankModels] = useState([]);
	const [embeddingsModels, setEmbeddingsModels] = useState([]);
	const [vectorModels, setVectorModels] = useState([]);
	const [ocrModels, setOcrModels] = useState([]);

	const STANDARD_MODELS = sortModelsByName(
		llmModels.filter(model => model.category === "standard")
	);
	const MEDIUM_MODELS = sortModelsByName(llmModels.filter(model => model.category === "medium"));
	const ADVANCED_MODELS = sortModelsByName(
		llmModels.filter(model => model.category === "advanced")
	);
	const CUSTOM_MODELS = sortModelsByName(llmModels.filter(model => model.category === "custom"));

	// Vector migration state
	const [selectedVectorMigration, setSelectedVectorMigration] = useState({
		embeddingsModel: settings?.models?.embeddingsModel,
		vectorModel: settings?.models?.vectorModel
	});

	const [migrationDialogOpen, setMigrationDialogOpen] = useState(false);

	const selectModel = (path, code) => {
		let copy = lod_.cloneDeep(settings);
		lod_.set(copy, `models.${path}`, code);
		setSettings(prev => copy);
	};

	const isMigrationNeeded = () => {
		const vectorModelDifferent =
			selectedVectorMigration.vectorModel !== settings?.models?.vectorModel;
		const embeddingModelDifferent =
			selectedVectorMigration.embeddingsModel !== settings?.models?.embeddingsModel;
		return vectorModelDifferent || embeddingModelDifferent;
	};

	const getModels = async () => {
		// On load, get all llm models
		const currentLlmModels = await new Promise(resolve => {
			dispatch(
				formActions.getItemsFromCollection(
					"llmModel",
					{
						query: {
							documentType: "llmModel",
							active: true
						},
						getInCatalogAndInClient: true
					},
					res => {
						resolve(res?.items ?? []);
					}
				)
			);
		});
		setLlmModels(currentLlmModels);

		const currentRankingModels = await new Promise(resolve => {
			// On load, get all ranking models
			dispatch(
				formActions.getItemsFromCollection(
					"llmModel",
					{
						query: {
							documentType: "rankingModel",
							active: true
						},
						getInCatalogAndInClient: true
					},
					res => {
						resolve(res?.items ?? []);
					}
				)
			);
		});
		setRerankModels(currentRankingModels);

		const currentEmbeddingsModels = await new Promise(resolve => {
			// On load, get all embeddings models
			dispatch(
				formActions.getItemsFromCollection(
					"llmModel",
					{
						query: {
							documentType: "embeddingsModel",
							active: true
						},
						getInCatalogAndInClient: true
					},
					res => {
						resolve(res?.items ?? []);
					}
				)
			);
		});
		setEmbeddingsModels(currentEmbeddingsModels);

		// On load, get all vector models
		const currentVectorModels = await new Promise(resolve => {
			dispatch(
				formActions.getItemsFromCollection(
					"llmModel",
					{
						query: {
							documentType: "vectorModel",
							active: true
						},
						getInCatalogAndInClient: true
					},
					res => {
						resolve(res?.items ?? []);
					}
				)
			);
		});

		const parsedModels = [];

		for (let model of currentVectorModels) {
			const config = model.config || {};
			let indexes = config.indexes;
			if (lod_.isNil(indexes) || lod_.isEmpty(indexes)) {
				indexes = [
					{
						index: config.index,
						algorithm: config.algorithm
					}
				];
			}

			for (let index of indexes) {
				let parsedModel = {
					id: `${model.code}-${index.algorithm}`,
					active: false,
					name: model.name,
					description: model.description,
					index: index.index,
					algorithmCode: index.algorithm,
					algorithm: {},
					code: model.code,
					provider: model.provider
				};

				const embeddingModel = currentEmbeddingsModels.find(
					m => m.config?.algorithm === index.algorithm
				);

				if (!lod_.isNil(embeddingModel)) {
					parsedModel.id = `${model.code}-${embeddingModel.code}`;
					parsedModel.active = true;
					parsedModel.algorithm = {
						code: embeddingModel.code,
						name: embeddingModel.name,
						description: embeddingModel.description,
						provider: embeddingModel.provider
					};
				}

				parsedModels.push(parsedModel);
			}
		}

		setVectorModels(parsedModels);

		// On load, get all OCR models
		const currentOcrModels = await new Promise(resolve => {
			dispatch(
				formActions.getItemsFromCollection(
					"llmModel",
					{
						query: {
							documentType: "ocrModel",
							active: true
						},
						getInCatalogAndInClient: true
					},
					res => {
						resolve(res?.items ?? []);
					}
				)
			);
		});
		setOcrModels(currentOcrModels);
	};

	useEffect(() => {
		getModels();
	}, []);

	return (
		<MDBox mt={3}>
			<MDTypography variant="h3">{t("SETTINGS.MODEL.modelChoice")}</MDTypography>

			<MDBox mt={3}>
				<Card>
					<CardContent>
						<MDBox display="flex" flexDirection="column">
							{/* Format model (only for admin) */}
							{hasAdvancedSettings && (
								<MDBox mt={2}>
									<FormControl fullWidth>
										<InputLabel
											style={{
												padding: "12px !important"
											}}
											id="select-model"
										>
											{t("CONFIG.rephraseModel")}
										</InputLabel>
										<Select
											labelId="select-model"
											value={settings?.models?.llmModelForFormat}
											label={t("CONFIG.rephraseModel")}
											onChange={e => {
												const selectedModelCode = e.target.value;
												selectModel("llmModelForFormat", selectedModelCode);
											}}
											renderValue={key => {
												const model = llmModels.find(m => m.code === key);
												if (!model) {
													return (
														<MDTypography variant="body1">
															{t("SETTINGS.MODEL.noModel")}
														</MDTypography>
													);
												}
												return (
													<MDBox display="flex">
														<ProviderBox provider={model.provider} alt={model?.options?.logoURL} />
														<MDBox>
															<MDTypography variant="h5" fontSize="medium">
																{model.name}
															</MDTypography>
															<MDBox>
																<MDTypography variant="body2" fontSize="small">
																	{model.description}
																</MDTypography>
															</MDBox>
														</MDBox>
													</MDBox>
												);
											}}
										>
											{/* Standard */}
											<ListSubheader>{t("SETTINGS.MODEL.standardModelDescription")}</ListSubheader>

											{STANDARD_MODELS.length === 0 && (
												<MenuItem
													disabled
													style={{
														display: "flex",
														justifyContent: "center"
													}}
												>
													<MDTypography variant="caption" fontSize="medium">
														{t("SETTINGS.MODEL.noModel")}
													</MDTypography>
												</MenuItem>
											)}
											{STANDARD_MODELS.map((model, index) => {
												return (
													<MenuItem key={index} value={model.code}>
														<ModelCardItem model={model} />
													</MenuItem>
												);
											})}
											{/* Medium */}
											<Divider />
											<ListSubheader>{t("SETTINGS.MODEL.mediumModelDescription")}</ListSubheader>

											{MEDIUM_MODELS.length === 0 && (
												<MenuItem
													disabled
													style={{
														display: "flex",
														justifyContent: "center"
													}}
												>
													<MDTypography variant="caption" fontSize="medium">
														{t("SETTINGS.MODEL.noModel")}
													</MDTypography>
												</MenuItem>
											)}
											{MEDIUM_MODELS.map((model, index) => {
												return (
													<MenuItem key={index} value={model.code}>
														<ModelCardItem model={model} />
													</MenuItem>
												);
											})}
											{/* Advanced */}
											<Divider />
											<ListSubheader>{t("SETTINGS.MODEL.advancedModelDescription")}</ListSubheader>

											{ADVANCED_MODELS.length === 0 && (
												<MenuItem
													disabled
													style={{
														display: "flex",
														justifyContent: "center"
													}}
												>
													<MDTypography variant="caption" fontSize="medium">
														{t("SETTINGS.MODEL.noModel")}
													</MDTypography>
												</MenuItem>
											)}
											{ADVANCED_MODELS.map((model, index) => {
												return (
													<MenuItem key={index} value={model.code}>
														<ModelCardItem model={model} />
													</MenuItem>
												);
											})}
											{/* Custom */}
											<Divider />
											<ListSubheader>{t("SETTINGS.MODEL.customModelDescription")}</ListSubheader>

											{CUSTOM_MODELS.length === 0 && (
												<MenuItem
													disabled
													style={{
														display: "flex",
														justifyContent: "center"
													}}
												>
													<MDTypography variant="caption" fontSize="medium">
														{t("SETTINGS.MODEL.noModel")}
													</MDTypography>
												</MenuItem>
											)}
											{CUSTOM_MODELS.map((model, index) => {
												return (
													<MenuItem key={index} value={model.code}>
														<ModelCardItem model={model} />
													</MenuItem>
												);
											})}
										</Select>
									</FormControl>
								</MDBox>
							)}
							{/* Reply model */}
							<MDBox mt={2}>
								<FormControl fullWidth>
									<InputLabel
										style={{
											padding: "12px !important"
										}}
										id="select-model"
									>
										{t("SETTINGS.MODEL.replyModel")}
									</InputLabel>
									<Select
										labelId="select-model"
										value={settings?.models?.llmModelForReply}
										label={t("SETTINGS.MODEL.replyModel")}
										onChange={e => {
											const selectedModelCode = e.target.value;
											selectModel("llmModelForReply", selectedModelCode);
										}}
										renderValue={key => {
											const model = llmModels.find(m => m.code === key);
											if (!model) {
												return (
													<MDTypography variant="body1">{t("SETTINGS.MODEL.noModel")}</MDTypography>
												);
											}
											return (
												<MDBox display="flex">
													<ProviderBox provider={model.provider} alt={model?.options?.logoURL} />
													<MDBox>
														<MDTypography variant="h5" fontSize="medium">
															{model.name}
														</MDTypography>
														<MDBox>
															<MDTypography variant="body2" fontSize="small">
																{model.description}
															</MDTypography>
														</MDBox>
													</MDBox>
												</MDBox>
											);
										}}
									>
										{/* Standard */}
										<ListSubheader>{t("SETTINGS.MODEL.standardModelDescription")}</ListSubheader>

										{STANDARD_MODELS.length === 0 && (
											<MenuItem
												disabled
												style={{
													display: "flex",
													justifyContent: "center"
												}}
											>
												<MDTypography variant="caption" fontSize="medium">
													{t("SETTINGS.MODEL.noModel")}
												</MDTypography>
											</MenuItem>
										)}
										{STANDARD_MODELS.map((model, index) => {
											return (
												<MenuItem key={index} value={model.code}>
													<ModelCardItem model={model} />
												</MenuItem>
											);
										})}
										{/* Medium */}
										<Divider />
										<ListSubheader>{t("SETTINGS.MODEL.mediumModelDescription")}</ListSubheader>

										{MEDIUM_MODELS.length === 0 && (
											<MenuItem
												disabled
												style={{
													display: "flex",
													justifyContent: "center"
												}}
											>
												<MDTypography variant="caption" fontSize="medium">
													{t("SETTINGS.MODEL.noModel")}
												</MDTypography>
											</MenuItem>
										)}
										{MEDIUM_MODELS.map((model, index) => {
											return (
												<MenuItem key={index} value={model.code}>
													<ModelCardItem model={model} />
												</MenuItem>
											);
										})}
										{/* Advanced */}
										<Divider />
										<ListSubheader>{t("SETTINGS.MODEL.advancedModelDescription")}</ListSubheader>

										{ADVANCED_MODELS.length === 0 && (
											<MenuItem
												disabled
												style={{
													display: "flex",
													justifyContent: "center"
												}}
											>
												<MDTypography variant="caption" fontSize="medium">
													{t("SETTINGS.MODEL.noModel")}
												</MDTypography>
											</MenuItem>
										)}
										{ADVANCED_MODELS.map((model, index) => {
											return (
												<MenuItem key={index} value={model.code}>
													<ModelCardItem model={model} />
												</MenuItem>
											);
										})}
										{/* Custom */}
										<Divider />
										<ListSubheader>{t("SETTINGS.MODEL.customModelDescription")}</ListSubheader>

										{CUSTOM_MODELS.length === 0 && (
											<MenuItem
												disabled
												style={{
													display: "flex",
													justifyContent: "center"
												}}
											>
												<MDTypography variant="caption" fontSize="medium">
													{t("SETTINGS.MODEL.noModel")}
												</MDTypography>
											</MenuItem>
										)}
										{CUSTOM_MODELS.map((model, index) => {
											return (
												<MenuItem key={index} value={model.code}>
													<ModelCardItem model={model} />
												</MenuItem>
											);
										})}
									</Select>
								</FormControl>
							</MDBox>
							{hasAdvancedSettings && (
								<>
									{/* Rerank model, display only if we have limits.rerankDocuments */}
									{settings.limits?.rerankDocuments === true && (
										<MDBox mt={2}>
											<FormControl fullWidth>
												<InputLabel
													style={{
														padding: "12px !important"
													}}
													id="select-model"
												>
													{t("SETTINGS.MODEL.rerankingModel")}
												</InputLabel>
												<Select
													labelId="select-model"
													value={settings?.models?.rerankModel}
													label={t("SETTINGS.MODEL.rerankingModel")}
													onChange={e => {
														const selectedModelCode = e.target.value;
														selectModel("rerankModel", selectedModelCode);
													}}
													renderValue={key => {
														const model = rerankModels.find(m => m.code === key);
														if (!model) {
															return (
																<MDTypography variant="body1">
																	{t("SETTINGS.MODEL.noModel")}
																</MDTypography>
															);
														}
														return (
															<MDBox display="flex">
																<ProviderBox
																	provider={model.provider}
																	alt={model?.options?.logoURL}
																/>
																<MDBox>
																	<MDTypography variant="h5" fontSize="medium">
																		{model.name}
																	</MDTypography>
																	<MDBox>
																		<MDTypography variant="body2" fontSize="small">
																			{model.description}
																		</MDTypography>
																	</MDBox>
																</MDBox>
															</MDBox>
														);
													}}
												>
													{rerankModels.map((model, index) => {
														return (
															<MenuItem key={index} value={model.code}>
																<ModelCardItem model={model} />
															</MenuItem>
														);
													})}
												</Select>
											</FormControl>
										</MDBox>
									)}
									{/* Vector storage */}
									<MDBox mt={2} display="flex">
										<FormControl fullWidth sx={{ flex: 5 }}>
											<InputLabel
												style={{
													padding: "12px !important"
												}}
												id="select-model"
											>
												{t("SETTINGS.MODEL.vectorStorage")}
											</InputLabel>
											<Select
												labelId="select-model"
												value={`${selectedVectorMigration?.vectorModel}-${selectedVectorMigration?.embeddingsModel}`}
												label={t("SETTINGS.MODEL.vectorStorage")}
												onChange={e => {
													const selectedModelCode = e.target.value;
													const model = vectorModels.find(m => m.id === selectedModelCode);

													if (lod_.isNil(model)) {
														return;
													}

													const newVectorModel = model.code;
													const newEmbeddingsModel = model.algorithm?.code;

													setSelectedVectorMigration({
														vectorModel: newVectorModel,
														embeddingsModel: newEmbeddingsModel
													});
												}}
												renderValue={key => {
													const model = vectorModels.find(m => m.id === key);

													if (!model) {
														return (
															<MDTypography variant="body1">
																{t("SETTINGS.MODEL.noModel")}
															</MDTypography>
														);
													}
													return (
														<VectorModelCardItem
															model={model}
															embeddingsModels={embeddingsModels}
														/>
													);
												}}
											>
												{vectorModels.map((model, index) => {
													return (
														<MenuItem
															key={index}
															value={model.id}
															disabled={!model.active}
															style={{
																display: "flex"
															}}
														>
															<VectorModelCardItem
																model={model}
																embeddingsModels={embeddingsModels}
															/>
														</MenuItem>
													);
												})}
											</Select>
										</FormControl>

										<MDButton
											sx={{ ml: 2, flex: 1 }}
											disabled={!isMigrationNeeded()}
											variant="gradient"
											color="info"
											onClick={() => setMigrationDialogOpen(true)}
										>
											{t("CONFIG.migrateDatas")}
										</MDButton>
										{/* Vector migration progress dialog */}
										<VectorMigrationDialog
											open={migrationDialogOpen}
											onClose={() => setMigrationDialogOpen(false)}
											selectedVectorMigration={selectedVectorMigration}
											loadConfig={loadConfig}
										/>
									</MDBox>
									{/* OCR model */}
									<MDBox mt={2}>
										<FormControl fullWidth>
											<InputLabel
												style={{
													padding: "12px !important"
												}}
												id="select-ocr-model"
											>
												{t("SETTINGS.MODEL.ocrModel")}
											</InputLabel>
											<Select
												labelId="select-ocr-model"
												value={settings?.models?.ocrModel}
												label={t("SETTINGS.MODEL.ocrModel")}
												onChange={e => {
													const selectedModelCode = e.target.value;
													selectModel("ocrModel", selectedModelCode);
												}}
												renderValue={key => {
													const model = ocrModels.find(m => m.code === key);
													if (!model) {
														return (
															<MDTypography variant="body1">
																{t("SETTINGS.MODEL.noModel")}
															</MDTypography>
														);
													}
													return (
														<MDBox display="flex">
															<ProviderBox
																provider={model.provider}
																alt={model?.options?.logoURL}
															/>
															<MDBox>
																<MDTypography variant="h5" fontSize="medium">
																	{model.name}
																</MDTypography>
																<MDBox>
																	<MDTypography variant="body2" fontSize="small">
																		{model.description}
																	</MDTypography>
																</MDBox>
															</MDBox>
														</MDBox>
													);
												}}
											>
												{ocrModels.length === 0 && (
													<MenuItem
														disabled
														style={{
															display: "flex",
															justifyContent: "center"
														}}
													>
														<MDTypography variant="caption" fontSize="medium">
															{t("SETTINGS.MODEL.noModel")}
														</MDTypography>
													</MenuItem>
												)}
												{ocrModels.map((model, index) => {
													return (
														<MenuItem key={index} value={model.code}>
															<ModelCardItem model={model} />
														</MenuItem>
													);
												})}
											</Select>
										</FormControl>
									</MDBox>
									{/* STT model */}
									<MDBox mt={2}>
										<FormControl fullWidth>
											<InputLabel
												style={{
													padding: "12px !important"
												}}
												id="select-stt-model"
											>
												{t("SETTINGS.MODEL.sttModel")}
											</InputLabel>
											<Select
												labelId="select-stt-model"
												value={settings?.models?.sttModel}
												label={t("SETTINGS.MODEL.sttModel")}
												onChange={e => {
													const selectedModelCode = e.target.value;
													selectModel("sttModel", selectedModelCode);
												}}
												renderValue={key => {
													const model = llmModels.find(m => m.code === key);
													if (!model) {
														return (
															<MDTypography variant="body1">
																{t("SETTINGS.MODEL.noModel")}
															</MDTypography>
														);
													}
													return (
														<MDBox display="flex">
															<ProviderBox
																provider={model.provider}
																alt={model?.options?.logoURL}
															/>
															<MDBox>
																<MDTypography variant="h5" fontSize="medium">
																	{model.name}
																</MDTypography>
																<MDBox>
																	<MDTypography variant="body2" fontSize="small">
																		{model.description}
																	</MDTypography>
																</MDBox>
															</MDBox>
														</MDBox>
													);
												}}
											>
												{/* Standard */}
												<ListSubheader>
													{t("SETTINGS.MODEL.standardModelDescription")}
												</ListSubheader>

												{STANDARD_MODELS.length === 0 && (
													<MenuItem
														disabled
														style={{
															display: "flex",
															justifyContent: "center"
														}}
													>
														<MDTypography variant="caption" fontSize="medium">
															{t("SETTINGS.MODEL.noModel")}
														</MDTypography>
													</MenuItem>
												)}
												{STANDARD_MODELS.map((model, index) => {
													return (
														<MenuItem key={index} value={model.code}>
															<ModelCardItem model={model} />
														</MenuItem>
													);
												})}
												{/* Medium */}
												<Divider />
												<ListSubheader>{t("SETTINGS.MODEL.mediumModelDescription")}</ListSubheader>

												{MEDIUM_MODELS.length === 0 && (
													<MenuItem
														disabled
														style={{
															display: "flex",
															justifyContent: "center"
														}}
													>
														<MDTypography variant="caption" fontSize="medium">
															{t("SETTINGS.MODEL.noModel")}
														</MDTypography>
													</MenuItem>
												)}
												{MEDIUM_MODELS.map((model, index) => {
													return (
														<MenuItem key={index} value={model.code}>
															<ModelCardItem model={model} />
														</MenuItem>
													);
												})}
												{/* Advanced */}
												<Divider />
												<ListSubheader>
													{t("SETTINGS.MODEL.advancedModelDescription")}
												</ListSubheader>

												{ADVANCED_MODELS.length === 0 && (
													<MenuItem
														disabled
														style={{
															display: "flex",
															justifyContent: "center"
														}}
													>
														<MDTypography variant="caption" fontSize="medium">
															{t("SETTINGS.MODEL.noModel")}
														</MDTypography>
													</MenuItem>
												)}
												{ADVANCED_MODELS.map((model, index) => {
													return (
														<MenuItem key={index} value={model.code}>
															<ModelCardItem model={model} />
														</MenuItem>
													);
												})}
												{/* Custom */}
												<Divider />
												<ListSubheader>{t("SETTINGS.MODEL.customModelDescription")}</ListSubheader>

												{CUSTOM_MODELS.length === 0 && (
													<MenuItem
														disabled
														style={{
															display: "flex",
															justifyContent: "center"
														}}
													>
														<MDTypography variant="caption" fontSize="medium">
															{t("SETTINGS.MODEL.noModel")}
														</MDTypography>
													</MenuItem>
												)}
												{CUSTOM_MODELS.map((model, index) => {
													return (
														<MenuItem key={index} value={model.code}>
															<ModelCardItem model={model} />
														</MenuItem>
													);
												})}
											</Select>
										</FormControl>
									</MDBox>
								</>
							)}
						</MDBox>
					</CardContent>
				</Card>
			</MDBox>
		</MDBox>
	);
}
